import { motion } from 'framer-motion';
import StepItem from './StepItem';

const ChatBubble = ({ message, index, allMessages, isLoading }) => {
  return (
    <motion.div initial={{ opacity: 0, y: 6 }} animate={{ opacity: 1, y: 0 }} className="">
      <div className="flex-1 min-w-0 space-y-3">
        <StepItem step={message} isLast={index === allMessages?.length - 1} isLoading={isLoading} />
      </div>
    </motion.div>
  );
};

export default ChatBubble;
